import { storyblokEditable } from "@storyblok/react";

const ContactSection = ({ blok }) => (
  <div {...storyblokEditable(blok)} className="contact-section">
    <h3>{blok.title}</h3>
    <p>{blok.subtitle}</p>
    <a href={blok.contactlink} className="button button-secondary"></a>
  </div>
);

export default ContactSection;
